export enum ConfigArea {
    OrganisationProfile,
    Access,
    Api,
    AI,
    Billing,
    CustomWelcomeEmail,
    ExternalLink,
    ValuesConstitution,
    CareerValuation,
    CulturalIndex,
    Tier1,
    People,
    PurposeAndVision,
    OwnersVision,
    ObjectivesAndKeyResults,
    CulturalLeadership,
    System,
    Kanban,
    Meetings,
    PeerCatchUp,
    Stakeholders,
    PersonalProfileCategories,
    Team,
    EmployeeEngagement,
    TeamAssessment,
    ResilientBusinessAssessment,
    ResilientBusinessGoals,
    TeamProfile,
    AccessPermissions,
    Notifications,
    Labels,
    CalendarIntegration,
    FeatureFlags,
    Bullseye,
    StrategyBoard,
    StrategicGoals,
    StrategicInputs,
    StrategicAnchors,
    PathwayCompletion,
    SingleSignOn,
    AccountSecurity,
    Progress,
    Theme,
    TeamAppearance,
}
